import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { formatInSiteTz, tzOffsetMin as offsetMin, tzZoneName as zoneName, fmtHours as hrs } from "@/lib/datetime";

// "Now: Wed 28 Oct 20:25 AEDT · 16 h notice → bookable from Thu 12:00" (+ booker's own time if it differs).
export default function SiteClockLine({ tz, leadH, stepMin = 30 }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  const fmt = (ms) => formatInSiteTz(new Date(ms).toISOString(), tz,
    { year: undefined, weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", hour12: false });
  const stepMs = stepMin * 60000;
  const first = leadH ? Math.ceil((now + leadH * 3600000) / stepMs) * stepMs : null;
  const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const diff = offsetMin(userTz, now) - offsetMin(tz, now);
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-600" data-testid="picker-site-clock">
      <span className="inline-flex items-center gap-1 font-medium text-slate-800">
        <Clock className="h-3.5 w-3.5" /> Now at site: <span data-testid="picker-site-now">{fmt(now)} {zoneName(tz, now)}</span>
      </span>
      {first && (
        <span data-testid="picker-notice-rule">
          · {leadH} h notice → bookable from <strong>{fmt(first)}</strong>
        </span>
      )}
      {diff !== 0 && (
        <span className="text-amber-700" data-testid="picker-your-time">
          · Your time: {formatInSiteTz(new Date(now).toISOString(), userTz, { year: undefined, month: undefined, day: undefined, hour: "2-digit", minute: "2-digit", hour12: false })} {zoneName(userTz, now)} ({hrs(diff)} {diff > 0 ? "ahead of" : "behind"} site). All times shown are site time.
        </span>
      )}
    </div>
  );
}
